import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { addressId, productSlug } = useLocalSearchParams<{
    addressId: string;
    productSlug: string;
  }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Delivery Customization — {addressId}/{productSlug}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
